import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewMarketImprovement } from "./DetailViewMarketImprovement";
import { MasterViewMarketImprovement } from "./MasterViewMarketImprovement";
export var TabImprovements = function () {
    var MasterDetailView = _MasterDetailView;
    return (React.createElement(MasterDetailView, { masterRenderer: MasterViewMarketImprovement, detailRenderer: DetailViewMarketImprovement }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/TabImprovements.tsx
// module id = 2705
// module chunks = 3